import isEqual from 'lodash/isEqual'
import { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { selectQuickWidgets } from "../../selectors/quickWidgets";
import { useStyles } from "./styles";
import MarketDepthWidget from "../common/quickWidgets/marketDepthWidget/marketDepthWidget";
import OrdersWidget from "../common/quickWidgets/ordersWidget/ordersWidget";
import { QuickWidgetTypes } from "../../reducer/user.reducer";
import { updateUserPreferences } from "../../services/apis/user";
import PositionsWidget from '../common/quickWidgets/positionsWidget/positionsWidget';
import QuickTradeWidget from '../common/quickWidgets/quickTradeWidget/quickTradeWidget';

const QuickWidgetsContainer: React.FC = () => {
    const quickWidgets = useSelector(selectQuickWidgets)

    const previousQuickWidgets = useRef(quickWidgets);
    useEffect(() => {
        if (!quickWidgets || !Object.values(quickWidgets).length) return;

        let timeout: number;

        if (!isEqual(previousQuickWidgets.current || {}, quickWidgets)) {
            previousQuickWidgets.current = quickWidgets
            timeout = window.setTimeout(() => {
                updateUserPreferences({
                    body: {
                        quickWidgets
                    }
                })
            }, 50)
        }

        return () => {
            clearTimeout(timeout)
        }
    }, [quickWidgets])
    const { classes } = useStyles();

    if (!quickWidgets) return null;
    return <div className={classes.container}>
        {
            Object.keys(quickWidgets).map((widgetType) => {
                const config = quickWidgets[widgetType as QuickWidgetTypes];

                if (!config || !config.enabled || !config.visible) return null;
                switch (widgetType) {
                    case QuickWidgetTypes.MARKET_DEPTH:
                        return <MarketDepthWidget key={widgetType} />
                    case QuickWidgetTypes.ORDER:
                        return <OrdersWidget key={widgetType} />
                    case QuickWidgetTypes.POSITION:
                        return <PositionsWidget key={widgetType} />
                    case QuickWidgetTypes.QUICK_TRADE:
                        return <QuickTradeWidget key={widgetType} />
                }
                return null
            })
        }
    </div>
}
export default memo(QuickWidgetsContainer);